import Box from '@material-ui/core/Box';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import { ReactComponent as ArrowdownSVG } from "assets/icons/arrow-down.svg";
import React, { useEffect, useState } from 'react';
import { ClearAll, Item } from './Theme';
import "./index.scss";

 export const MenuMultiCheckBox = ({ Items, formik, isLedger, field, withBorder,styles,width,height }) => {
    const useStyles = makeStyles({
        inputAdornment: {
            '& .MuiSvgIcon-root': {
                cursor: 'pointer',
            },
        },
    });
    const classes = useStyles();
    const [selectAll, setSelectAll] = useState(false);
    const handleOptionToggle = (option, type, id) => () => {
        const currentIndex = formik?.values[field].some(val => val.id === id);
        let newSelectedOptions = [...formik?.values[field]];
        if (currentIndex === false) {
            newSelectedOptions.push({ label: option, id: id, type: type });
            console.log("if newSelectedOptions", newSelectedOptions, newSelectedOptions.length === Items.length, Items);
        } else {
            setSelectAll(false);
            formik.setFieldValue("selectAllLedger", false);
            formik.setFieldValue("selectAllSubLedger", false);
            newSelectedOptions = newSelectedOptions.filter(item => item.id !== id);
        }

        formik.setFieldValue(field, newSelectedOptions);
        // to check subledger length that came from BE
        const ItemsLedger = Items.filter(val => val !== 'Select All');
        const ItemSubLedgerLength = ItemsLedger.reduce((acc, arr) => acc + arr?.sub_ledgers?.length, 0);
        const ledger = newSelectedOptions.filter(val => val?.type === 'ledger' && val.id)
        const subledger = newSelectedOptions.filter(val => val?.type === 'sub_ledger' && val.id)
        const isAll = ledger?.length === ItemsLedger?.length && ItemSubLedgerLength === subledger?.length

        const isAllLedger = ledger?.length === ItemsLedger?.length
        const isAllSubLedger = ItemSubLedgerLength === subledger?.length
        if (isAllLedger) {
            formik.setFieldValue("selectAllLedger", true);
        } else {
            formik.setFieldValue("selectAllLedger", false);
        }
        if (isAllSubLedger) {
            formik.setFieldValue("selectAllSubLedger", true);
        } else {
            formik.setFieldValue("selectAllSubLedger", false);
        }
        
        if (isAll) {
            setSelectAll(true);
        }
        if (isLedger) {
            isAll ? type === 'ledger' ? formik.setFieldValue("ledger", []) : formik.setFieldValue("subLedger", []) : type === 'ledger' ?
                formik.setFieldValue("ledger", ledger?.map(obj => obj.id)) : formik.setFieldValue("subLedger", subledger?.map(obj => obj.id));
        }
    };
    const handleSelectAllToggle = () => {
        if (selectAll) {
            formik.setFieldValue(field, []);
            formik.setFieldValue("selectAllLedger", false);
            formik.setFieldValue("selectAllSubLedger", false);
        } else {
            const allOptions = []
            const all = Items?.map((row, rowIndex) => {
                console.log("row", row);
                if (row !== "Select All") {
                    allOptions.push({ label: row.ledger_name, id: row?._id, type: 'ledger' })
                    const Sub = row?.sub_ledgers?.map((cell) => {
                        allOptions.push({ label: cell?.sub_ledger_name, id: cell?._id, type: 'sub_ledger' })
                    })
                }
            })
            formik.setFieldValue(field, allOptions);
            formik.setFieldValue("selectAllLedger", true);
            formik.setFieldValue("selectAllSubLedger", true);
            if (isLedger) {
                formik.setFieldValue("ledger", []);
                formik.setFieldValue("subLedger", []);
            }
        }
        setSelectAll(!selectAll);
    };
    const handleClearAllToggle = () => {
        formik.setFieldValue(field, []);
        formik.setFieldValue("selectAllLedger", false);
        formik.setFieldValue("selectAllSubLedger", false);
        if (isLedger) {
            formik.setFieldValue("ledger", []);
            formik.setFieldValue("subLedger", []);
        }
        setSelectAll(false);
    }
    useEffect(() => {
        formik?.values[field]?.length === 0 && setSelectAll(false)
    }, [formik?.values])


    const renderOption = (props, option) => {
        if (option === 'Select All') {
            return (
                <li {...props} className="select_all">
                    <div onClick={handleSelectAllToggle}>
                        <Checkbox checked={selectAll}
                            sx={{
                                padding: '0px',
                            }}
                        />All
                    </div>
                    <ClearAll key="clear-all" onClick={handleClearAllToggle} disabled={formik?.values[field]?.length === 0}>
                        Clear All
                    </ClearAll>
                </li>
            );
        } else {
            return (
                <li {...props} className='li_hover' key={option?._id}>
                    <div>
                        <Item  value={option} onClick={handleOptionToggle(option?.ledger_name, 'ledger', option?._id)}
                        >
                            <FormControlLabel
                                label={
                                    <Typography sx={{ fontSize: 18 }}>
                                        {option?.ledger_name}
                                    </Typography>
                                }
                                control={
                                    <Checkbox
                                        checked={formik?.values[field].some(val => val.id === option?._id)}
                                        sx={{
                                            padding: '0px',
                                        }}
                                    />
                                }

                            />
                        </Item>

                        {option?.sub_ledgers?.length > 0 &&

                            <div>{
                                option?.sub_ledgers?.map((childOption) => (
                                    <Box key={childOption?.id} sx={{ display: 'flex', flexDirection: 'column', ml: 5, color: '#4f4f4f', fontWight: 'normal' }}
                                        onClick={handleOptionToggle(childOption?.sub_ledger_name, 'sub_ledger', childOption?._id)}>
                                        <FormControlLabel
                                            label={<Typography sx={{ fontSize: 18 }}>
                                                {childOption?.sub_ledger_name}
                                            </Typography>}
                                            control={<Checkbox
                                                checked={formik?.values[field].some(val => val.id === childOption?._id)}
                                                sx={{
                                                    padding: '0px',
                                                }}
                                            />

                                            }
                                        />

                                    </Box>

                                ))
                            }
                            </div>}


                    </div>
                </li>
            );
        }
    };
    return (
        <div className='menuMultiCheckBox' >
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                className={classes.root}
                disableCloseOnSelect
                noOptionsText="No related ledgers or subLedgers is available"
                options={Items}
                getOptionLabel={(option) => [option?.ledger_name, option?.sub_ledgers?.map((item) => item?.sub_ledger_name)]}
                sx={styles ? styles : {
                    background: "#fff",
                    maxHeight: '52px !important',

                    width: width || '312px',
                    borderRadius: '5px',

                    '&.MuiFormControl-fullWidth': {
                        borderRadius: '5px',
                        height: '52px',
                        
                    },
                    '&:hover': {
                        border: !withBorder && '1px solid #cccccc'
                    },
                    '&& fieldset': {
                        width: width || '312px',
                        maxHeight: '52px !important',
                        justifyContent: 'center',
                        border: !withBorder && "0",
                    },

                    '&.Mui-focused ': {
                        maxHeight: '52px !important',
                        border: !withBorder && "1px solid #03b2cb",
                        boxShadow: !withBorder && '0 0 0 3px rgba(52,152,255,.25)',
                        '&& fieldset': {
                            maxHeight: '52px !important',
                            border: !withBorder && "0",
                        },
                    },
                }}
                disableClearable
                renderOption={renderOption}
                renderInput={(params) => (
                    <TextField {...params}
                        placeholder={`Selected Options: ${formik?.values[field]?.length}`}
                        sx={{
                            input: {
                                color: 'black',
                                "&::placeholder": {
                                    opacity: formik?.values[field]?.length === 0 ? 0.5 : 1,
                                },
                            },
                        }}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                < ArrowdownSVG fill={'#B5B5C3'} style={{
                                    width: '13px',
                                    cursor: 'pointer',
                                    marginRight: '-12px',
                                    marginTop: '-3px'

                                }} />

                            ),
                            classes: {
                                endAdornment: classes.inputAdornment, // Apply custom styles
                            },
                            style: { 
                                height: height || 46,
                                padding: "5px 9px",
                                paddingRight: "20px",                               
                            },

                        }}
                    />
                )}
                renderTags={(value, getTagProps) =>
                    <span>
                    </span>
                }
            >
            </Autocomplete>
        </div >

    );
};